



























































































import InputOTP from '@/app/ui/components/InputOTP/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import LionParcelLogo from '@/app/ui/assets/lion_parcel_logo.vue'
import IconArrowLeft from '@/app/ui/assets/ics_o_arrow_left.vue'
import { Component, Prop, Vue } from 'vue-property-decorator';
import Ics_f_warning_circle_red from '@/app/ui/assets/ics_f_warning_circle_red.vue';

@Component({
  components: {
    InputOTP,
    Button,
    LionParcelLogo,
    IconArrowLeft,
    Ics_f_warning_circle_red
  }
})
class VerifyOTP extends Vue {
  @Prop({ default: '', required: true, type: String })
  public otpErrorMessage!: string
  @Prop({ default: '', required: true, type: String }) public email!: string
  @Prop({ default: false, type: Boolean, required: true })
  public disabled!: boolean
  @Prop({ default: false, type: Boolean, required: false })
  public isErrorRequestOTP!: boolean
  @Prop({ default: 300 })
  public cooldownIn!: number

  otp = ''
  requestOtpCountdown = '00 : 00'
  canRequestOTP = false
  countDownInterval: any = null

  goBack(): void {
    this.$emit("back");
  }

  get isOTPValid(): boolean {
    return this.otp.length === 6
  }

  mounted(): void {
    this.setOTPCountDown(this.cooldownIn)
  }

  unmounted(): void {
    if (this.countDownInterval) clearInterval(this.countDownInterval)
  }

  requestOTP(): void {
    this.$emit('request')
  }

  async verifyOTP(): Promise<void> {
    this.$emit('verify', this.otp)
  }

  setOTPCountDown(second: number): void {
    if (this.countDownInterval) {
      clearInterval(this.countDownInterval)
    }

    this.canRequestOTP = false
    const retryCountdown = Date.now() + second * 1000

    const updateCountdown = () => {
      const remaining = retryCountdown - Date.now()

      if (remaining <= 0) {
        this.canRequestOTP = true
        this.requestOtpCountdown = '00 : 00'

        if (this.countDownInterval) {
          clearInterval(this.countDownInterval)
        }

        return
      }

      const minutes = Math.floor(remaining / 1000 / 60)
      const seconds = Math.floor((remaining / 1000) % 60)

      this.requestOtpCountdown =
        `${String(minutes).padStart(2, '0')} : ${String(seconds).padStart(2, '0')}`
    }

    updateCountdown()
    this.countDownInterval = setInterval(updateCountdown, 1000)
  }

  onEnterOTP(): void {
    if (!this.isOTPValid) return;
    this.verifyOTP();
  }

  public restartCountdown(second: number): void {
    this.setOTPCountDown(second)
  }
}

export default VerifyOTP;
